export const PASSPORT_UPLOAD_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const PASSPORT_UPLOAD_ACCEPT = 'image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf';

const supportedMimeTypes = ['image/jpeg', 'image/png', 'application/pdf'];
const supportedFileExtensions = ['.jpg', '.jpeg', '.png', '.pdf'];

const hasSupportedExtension = fileName => {
  const normalizedFileName = fileName ? fileName.toLowerCase() : '';
  return supportedFileExtensions.some(extension => normalizedFileName.endsWith(extension));
};

export const validatePassportUploadFile = file => {
  if (!file) {
    return { isValid: false, errorId: 'FileUploader.passportUploadFailed' };
  }

  const normalizedMimeType = file.type ? file.type.toLowerCase() : '';
  const hasSupportedType =
    supportedMimeTypes.includes(normalizedMimeType) || hasSupportedExtension(file.name);

  if (!hasSupportedType) {
    return { isValid: false, errorId: 'FileUploader.passportInvalidType' };
  }

  if (file.size > PASSPORT_UPLOAD_MAX_FILE_SIZE) {
    return { isValid: false, errorId: 'FileUploader.passportTooLarge' };
  }

  return { isValid: true, errorId: null };
};

export const getPassportUploadError = error => {
  const rawMessage =
    typeof error === 'string' ? error : error?.error || error?.message || error?.statusText || null;

  if (!rawMessage) {
    return { errorId: 'FileUploader.passportUploadFailed', errorText: null };
  }

  if (/File too large/i.test(rawMessage)) {
    return { errorId: 'FileUploader.passportTooLarge', errorText: null };
  }

  if (/Only \.jpg|Only \.pdf|Unexpected field|unknown error/i.test(rawMessage)) {
    return { errorId: 'FileUploader.passportInvalidType', errorText: null };
  }

  return { errorId: null, errorText: rawMessage };
};
